export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Te contactamos y valoramos tu vivienda',
      description: 'Analizamos tu propiedad y te damos una estimación realista de ingresos potenciales sin compromiso.'
    },
    {
      number: '02',
      title: 'Activamos tu anuncio en Airbnb y Booking',
      description: 'Creamos anuncios profesionales con fotos de calidad y descripciones optimizadas para atraer huéspedes.'
    },
    {
      number: '03',
      title: 'Tú cobras cada mes sin preocuparte de nada',
      description: 'Gestionamos reservas, limpieza, check-in/out y atención al cliente. Tú solo recibes tus ingresos.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-['Andrea'] text-4xl lg:text-5xl font-bold text-[#2C3E50] mb-4">
            Así de fácil es alquilar con nosotros
          </h2>
          <p className="font-['Satoshi'] text-lg text-gray-600 max-w-2xl mx-auto">
            Un proceso simple y transparente en solo 3 pasos
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-12 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col items-center text-center">
                <div className="w-24 h-24 flex items-center justify-center bg-[#2C3E50] rounded-full mb-6 relative z-10">
                  <span className="font-['Andrea'] text-3xl font-bold text-white">
                    {step.number}
                  </span>
                </div>
                
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-12 left-1/2 w-full h-0.5 bg-[#E8DCC4]" style={{ zIndex: 0 }}></div>
                )}

                <h3 className="font-['Andrea'] text-xl font-bold text-[#2C3E50] mb-4 px-4">
                  {step.title}
                </h3>
                <p className="font-['Satoshi'] text-sm text-gray-600 leading-relaxed px-4">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a 
            href="https://wa.me/34633123150"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#2C3E50] text-white font-['Satoshi'] font-semibold py-4 px-8 rounded-md hover:bg-[#34495E] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Comienza ahora
          </a>
        </div>
      </div>
    </section>
  );
}
